import moment from 'moment';
import _ from 'lodash';

import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { BaseSchema } from '../baseSchema';

export const GroupBillsPayments = new Mongo.Collection('groupbillspayments');

GroupBillsPayments.attachRoles('groupbillspayments');

export const GroupBillsPayment = new SimpleSchema([{
	type: {
		type: String,
		label: "Type",
	},
	montant: {
		type: Number,
		label: "Montant"
	},
	bill: {
		type: String,
		label: "Identifiant de la facture"
	},
	informations: {
		type: String,
		label: "Informations",
		optional: true
	}
  }, BaseSchema]);

GroupBillsPayments.attachSchema(GroupBillsPayment);

// Dbs methods :

Meteor.methods({
	'groupbills.payments.insert'(attributes) {
		console.log('attribues', attributes);
		GroupBillsPayments.insert(attributes);
	},
	'groupbills.payments.remove'(_id) {
		GroupBillsPayments.remove(_id);
	}
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/partners/group-bills-payments.js
 **/